<template>
  <div class="main text-left">
    <div class="form-group">
      <label class="text-muted small">メールアドレス <span class="text-danger">*必須</span></label>
      <input type="email" class="form-control form-control-sm" v-model="input.username" :maxlength="50"
        placeholder="メールアドレス">
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="register()">パスワード再発行</span>
    <small class="form-text text-muted">すでにアカウントをお持ちですか？<span class="btn btn-sm btn-link"
        v-on:click="toLogin()">ログイン</span></small>
  </div>
</template>
<script>
import sx from '../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        username: ''
      },
      confirmdef: {
        title: 'パスワード再発行',
        msg: '再発行したパスワードはメールに送信します。<br>継続しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  created() {
    this.$store.state.title = 'パスワード再発行'
    this.$store.state.confirmdef = this.confirmdef
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    register() {
      const that = this
      if (that.input.username != '') {
        $('#myModalConfirm').modal('show')
        $("#confirm").click(function () {
          $('#myModalConfirm').modal('hide')
          if (that.$router.currentRoute.name != "Recovery") {
            return
          }
          sx.showWaiting()
          var params = {
            username: that.input.username,
            token: ''
          }
          sx.request(
            that.$store.state.baseurl + '/app/account/recovery',
            params,
            function (result) {
              if (result.status === 'ok') {
                sx.hideWaiting()
                sx.toastSuccess('パスワード再発行しました。<br>ログイン画面に遷移します！')
                that.$router.replace({ name: 'Login' })
              } else if (result.status === 'err') {
                sx.toastError('再発行するためにメール送信に失敗しました！')
              } else {
                sx.toastError('アカウントは存在しません！')
              }
            },
            function (result) {
              sx.hideWaiting()
              sx.toastError('パスワード再発行に失敗しました！')
              console.log('recovery failed')
            }
          )
          sx.hideWaiting()
        })
      } else {
        sx.toastError('メールアドレスを入力してください！')
        console.log('username must be present')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding: 20px;
}
</style>
